const parseDate = (date: string): Date => {
    const dateObject = new Date(date);

    return new Date(
        dateObject.getFullYear(),
        dateObject.getMonth(),
        dateObject.getDate(),
        0,
        0,
        0,
        0,
    );
};

export default parseDate;
